import { createSlice } from '@reduxjs/toolkit'
import { fetchAllCouriers, addNewCourier, updateCourier } from '../actions/courierActions'

const CourierReducers = createSlice({
    name: 'CourierReducers',
    initialState: {
        loader: false,
        errors: null,
        courier: null,
        couriers: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * ALL Couriers
             */
            .addCase(fetchAllCouriers.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(fetchAllCouriers.fulfilled, (state, action) => {
                state.loader = false;
                state.couriers = action.payload.data;
            })
            .addCase(fetchAllCouriers.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * Add new courier
             */
            .addCase(addNewCourier.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(addNewCourier.fulfilled, (state, action) => {
                state.loader = false;
                state.courier = action.payload.data;
            })
            .addCase(addNewCourier.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * Update courier
             */
            .addCase(updateCourier.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(updateCourier.fulfilled, (state, action) => {
                state.loader = false;
                state.courier = action.payload.data;

                // Optional: Update the courier inside the couriers list too
                const updated = action.payload.data;
                const index = state.couriers.findIndex(courier => courier.id === updated.id);
                if (index !== -1) {
                    state.couriers[index] = updated;
                }
            })
            .addCase(updateCourier.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })
    }
})

export default CourierReducers.reducer